import { Injectable } from '@angular/core';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResourceData } from '@app/shared/abstract/resource.data';
import { ProductModel } from './product.model';

@Injectable({
  providedIn: 'root',
})
export class ProductService extends AbstractEntityService<ProductModel> {
  constructor(http: HttpClient) {
    super('/api/products', http);
  }

  saveFormData(formData: FormData, productId?: number | null): Observable<ResourceData<ProductModel>> {
    if (productId) {
      return this.http.post<ResourceData<ProductModel>>(`${this.apiUrl}${this.basePath}/${productId}`, formData);
    } else {
      return this.http.post<ResourceData<ProductModel>>(`${this.apiUrl}${this.basePath}`, formData);
    }
  }
}
